module.exports = __webpack_public_path__ + "img/unknown.e82b7fe0.png";